import React, {useEffect, useState} from 'react'
import axios from "axios";
import Parser from "html-react-parser";
import {Link} from "react-router-dom";

const Loader = () => (
    <div className="loadingData2">
        <div className="spinner"></div>
    </div>
);

const Post = React.memo(({post}) => {
    const date = new Date(post.date);
    date.toLocaleDateString("fr");

    const [media, setMedia] = useState(null);
    const [errorM, setErrorM] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchMedia = async () => {
            try {
                const url = `${process.env.REACT_APP_WP_API_URL_V2}/media/${post.featured_media}`;
                const {data} = await axios.get(url);
                setMedia(data.guid.rendered);
            } catch (e) {
                setErrorM('No image');
            } finally {
                setIsLoading(false);
            }
        };

        fetchMedia();
    }, [post.featured_media]);

    return (
        <li>
            <div className="illustration">
                {isLoading ? (
                    <Loader />
                ) : errorM ? (
                    <h3>{errorM}</h3>
                ) : (
                    <Link to={`/blog/${post.slug}`} className={'articles'}>
                        <img key={post.id} src={media} alt={post.title.rendered} />
                        <span>{Parser(post.title.rendered)}</span>
                    </Link>
                )}
            </div>
        </li>
    );
});

const WordpressApi2 = () =>{
    const [posts, setPosts] = useState([]);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const wpCategories = process.env.REACT_APP_WP_CATEGORIES;
                const url = `${process.env.REACT_APP_WP_API_URL_V2}/posts`;
                const {data} = await axios.get(
                    url,
                    {
                        params: {
                            _fields: [
                                'id',
                                'content',
                                'categories',
                                'title',
                                'date',
                                'featured_media',
                                'slug',
                                'author_info',
                                'status'
                            ],
                            status:"publish",
                            categories: wpCategories
                        }
                    }
                );
                setPosts(data);
            } catch (e) {
                setError('Something went wrong.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchPosts();
    }, []);

    return (
        <>
            <ul className="stand-actualite">
                {error && <h3>{error}</h3>}
                {isLoading && <Loader />}
                {posts.slice(0, 3).map(p => <Post key={p.id} post={p} />)}
            </ul>
            <div className="d-flex justify-content-center mt-2">
                <Link className="theme-btn btn-style-one small mt-3" to="/blog">Voir les actualités</Link>
            </div>
        </>
    );
}

export default WordpressApi2;